export const propertySchema = {
  description: {
    type: "string",
    placeholder: "Springville House"
  },
  value: {
    type: "integer"
  },
  property_taxes: {
    type: "integer",
    required: true,
    defaultValue: "0"
  },
  is_primary_residence: {
    type: "boolean",
    required: false,
    defaultValue: false
  },
  type: {
    type: "string",
    defaultValue: "realestate"
  }
}
